import { IStatsWrapper } from '@/types/analytics';

const createEmptyStatsWrapper = <T>(data?: T): IStatsWrapper<T> => ({
  loading: false,
  data: data || null,
  error: null,
  initialRequestMade: false,
});

export default createEmptyStatsWrapper;
